import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** The bar shown above the page on small screens, where the sidebar is folded away. */
@Component({
    selector: 'app-mobile-topbar',
    templateUrl: './mobile-topbar.component.html',
    styleUrls: ['./mobile-topbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MobileTopbarComponent {
    @Input({ required: true }) logo = '';
    @Input() menuOpen = false;
    @Output() readonly menuToggle = new EventEmitter<void>();
}
